var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "Lịch sử thao tác camera - Lớp: " + (_vm.className || ""),
        visible: _vm.dialogVisible,
        width: "85%",
        "before-close": _vm.closeDialog,
        "close-on-click-modal": false,
        top: "5vh",
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
      },
    },
    [
      _vm.loadError
        ? _c(
            "div",
            { staticClass: "history-error-banner" },
            [
              _c("span", { staticClass: "error-text" }, [
                _c("i", { staticClass: "el-icon-warning-outline" }),
                _vm._v(
                  "\n      " +
                    _vm._s(
                      _vm.errorMessage ||
                        "Không thể tải lịch sử thao tác camera."
                    ) +
                    "\n    "
                ),
              ]),
              _c(
                "el-button",
                {
                  attrs: {
                    type: "danger",
                    size: "mini",
                    plain: "",
                    icon: "el-icon-refresh",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.fetchData()
                    },
                  },
                },
                [_vm._v("\n      Thử lại\n    ")]
              ),
            ],
            1
          )
        : _vm._e(),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loadingData,
              expression: "loadingData",
            },
          ],
          ref: "historyTable",
          attrs: {
            "element-loading-text": _vm.$tableLoading,
            "element-loading-spinner": "el-icon-loading",
            "element-loading-background": "rgba(255,255,255, 0.5)",
            "highlight-current-row": "",
            "row-key": "operationId",
            data: _vm.historyRows,
            "empty-text": _vm.tableEmptyText,
            "header-cell-style": _vm.tableHeaderColor,
            "max-height": _vm.$tableMaxHeightSmall,
            border: "",
          },
        },
        [
          _c("el-table-column", {
            attrs: {
              type: "index",
              index: _vm.indexMethod,
              label: "STT",
              width: "55",
              align: "center",
            },
          }),
          _c("el-table-column", {
            attrs: { label: "Thời gian", width: "165", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("span", [
                      _c("i", {
                        staticClass: "el-icon-time",
                        staticStyle: {
                          "margin-right": "4px",
                          color: "#409EFF",
                        },
                      }),
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm._f("formatDateTime")(scope.row.changedAt)
                          ) +
                          "\n        "
                      ),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "Người thao tác", width: "190" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.actorName
                      ? _c("span", { staticStyle: { "font-weight": "500" } }, [
                          _c("i", {
                            staticClass: "el-icon-user",
                            staticStyle: {
                              "margin-right": "4px",
                              color: "#67C23A",
                            },
                          }),
                          _vm._v(
                            "\n          " +
                              _vm._s(scope.row.actorName) +
                              "\n        "
                          ),
                        ])
                      : _c(
                          "span",
                          {
                            staticStyle: {
                              color: "#909399",
                              "font-style": "italic",
                            },
                          },
                          [
                            _c("i", {
                              staticClass: "el-icon-user",
                              staticStyle: { "margin-right": "4px" },
                            }),
                            _vm._v(
                              "\n          Tài khoản #" +
                                _vm._s(scope.row.actorUserId) +
                                "\n        "
                            ),
                          ]
                        ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "Loại thao tác", width: "150", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.addedCount > 0 && scope.row.removedCount > 0
                      ? _c(
                          "el-tag",
                          {
                            attrs: {
                              type: "warning",
                              size: "small",
                              effect: "plain",
                            },
                          },
                          [_vm._v("\n          Thêm & Loại bỏ\n        ")]
                        )
                      : scope.row.addedCount > 0
                      ? _c(
                          "el-tag",
                          {
                            attrs: {
                              type: "success",
                              size: "small",
                              effect: "plain",
                            },
                          },
                          [_vm._v("\n          Thêm\n        ")]
                        )
                      : scope.row.removedCount > 0
                      ? _c(
                          "el-tag",
                          {
                            attrs: {
                              type: "danger",
                              size: "small",
                              effect: "plain",
                            },
                          },
                          [_vm._v("\n          Loại bỏ\n        ")]
                        )
                      : _c(
                          "el-tag",
                          {
                            attrs: {
                              type: "info",
                              size: "small",
                              effect: "plain",
                            },
                          },
                          [_vm._v("\n          Không đổi\n        ")]
                        ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "Camera thêm", "min-width": "220" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.addedCount > 0
                      ? _c("div", [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                "font-weight": "600",
                                color: "#67C23A",
                                "margin-bottom": "4px",
                              },
                            },
                            [
                              _c("i", {
                                staticClass: "el-icon-circle-plus-outline",
                              }),
                              _vm._v(
                                " Thêm " +
                                  _vm._s(scope.row.addedCount) +
                                  " mắt:\n          "
                              ),
                            ]
                          ),
                          _c(
                            "div",
                            { staticClass: "camera-tag-list" },
                            _vm._l(scope.row.addedCameras, function (cam) {
                              return _c(
                                "el-tag",
                                {
                                  key: cam.id,
                                  staticStyle: { margin: "2px 4px 2px 0" },
                                  attrs: { type: "success", size: "mini" },
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(cam.camName) +
                                      "\n            "
                                  ),
                                ]
                              )
                            }),
                            1
                          ),
                        ])
                      : _c("span", { staticStyle: { color: "#C0C4CC" } }, [
                          _vm._v("—"),
                        ]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "Camera loại bỏ", "min-width": "220" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.removedCount > 0
                      ? _c("div", [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                "font-weight": "600",
                                color: "#F56C6C",
                                "margin-bottom": "4px",
                              },
                            },
                            [
                              _c("i", {
                                staticClass: "el-icon-remove-outline",
                              }),
                              _vm._v(
                                " Loại bỏ " +
                                  _vm._s(scope.row.removedCount) +
                                  " mắt:\n          "
                              ),
                            ]
                          ),
                          _c(
                            "div",
                            { staticClass: "camera-tag-list" },
                            _vm._l(scope.row.removedCameras, function (cam) {
                              return _c(
                                "el-tag",
                                {
                                  key: cam.id,
                                  staticStyle: { margin: "2px 4px 2px 0" },
                                  attrs: { type: "danger", size: "mini" },
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(cam.camName) +
                                      "\n            "
                                  ),
                                ]
                              )
                            }),
                            1
                          ),
                        ])
                      : _c("span", { staticStyle: { color: "#C0C4CC" } }, [
                          _vm._v("—"),
                        ]),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "div",
            { staticClass: "dialog-footer-content" },
            [
              _c("el-pagination", {
                attrs: {
                  background: "",
                  "current-page": _vm.currentPage,
                  "page-sizes": [10, 20, 50, 100],
                  "page-size": _vm.pageSize,
                  layout: "total, sizes, prev, pager, next",
                  total: _vm.historyTotal,
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.handleCurrentChange,
                },
              }),
              _c(
                "div",
                { staticClass: "dialog-action-buttons" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: {
                        size: "medium",
                        type: "primary",
                        plain: "",
                        icon: "el-icon-refresh",
                        loading: _vm.loadingData,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.fetchData()
                        },
                      },
                    },
                    [_vm._v("\n          Làm mới\n        ")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "danger", size: "medium" },
                      on: {
                        click: function ($event) {
                          return _vm.closeDialog()
                        },
                      },
                    },
                    [
                      _c("i", { staticClass: "el-icon-circle-close" }),
                      _c("span", [_vm._v(_vm._s(_vm.$t("button.close")))]),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }